import vad from 'voice-activity-detection';
import EventEmitter from './EventEmitter';

class AudioManipulator extends EventEmitter {
  constructor(stream, applyAudioProcessing) {
    super();
    this.inputStream = stream;
    this.applyAudioProcessing = applyAudioProcessing;
  }

  async init() {
    // Device detection for conditional processing
    const isMobile = /iPhone|iPad|iPod|Android/i.test(
      window.navigator.userAgent
    );

    if (isMobile) {
      // Directly assign input to output for mobile devices
      this.outputStream = this.inputStream;
    } else {
      // Create an AudioContext for non-mobile devices with additional processing
      const context = new AudioContext({ latencyHint: 'interactive' });
      this.context = context;

      const source = context.createMediaStreamSource(this.inputStream);

      // High-Pass Filter
      const highPassFilter = context.createBiquadFilter();
      highPassFilter.type = 'highpass';
      highPassFilter.frequency.value = 120;

      // Low-Pass Filter
      const lowPassFilter = context.createBiquadFilter();
      lowPassFilter.type = 'lowpass';
      lowPassFilter.frequency.value = 5000;

      // Connect filters in sequence and output
      source.connect(highPassFilter);
      highPassFilter.connect(lowPassFilter);

      // Destination stream for non-mobile devices
      this.destination = context.createMediaStreamDestination();
      this.outputStream = this.destination.stream;
      lowPassFilter.connect(this.destination);
    }

    // this.outputStream = this.inputStream;
    this.vadContext = null;
    this.vadDestroy = null;
  }

  setInputStream(stream) {
    this.inputStream = stream;
    if (this.vadDestroy) {
      this.deactivateVad();
      this.activateVad();
    }
  }

  mute() {
    this.outputStream.getTracks().forEach((track) => (track.enabled = false));
  }

  unmute() {
    this.outputStream.getTracks().forEach((track) => (track.enabled = true));
  }

  activateVad() {
    if (!this.vadDestroy) {
      const context = new AudioContext({
        latencyHint: 'interactive',
      });
      const { destroy } = vad(context, this.inputStream, {
        minNoiseLevel: 0.5,
        maxNoiseLevel: 0.7,
        onVoiceStart: () => {
          this.emit('voice', true);
        },
        onVoiceStop: () => {
          this.emit('voice', false);
        },
        onUpdate: (val) => {
          this.emit('level', val);
        },
      });
      this.vadContext = context;
      this.vadDestroy = destroy;
    }
  }

  deactivateVad() {
    if (this.vadDestroy) {
      this.vadContext.close();
      this.vadDestroy();
      this.vadDestroy = null;
    }
  }

  getOutputStream() {
    return this.outputStream;
  }

  destroy() {
    this.deactivateVad();

    this.removeAllListeners();
    this.inputStream = null;

    if (this.outputStream) {
      this.outputStream = null;
    }

    if (this.context) {
      this.context.close();
      this.gainNode = null;
      this.adaptiveGainNode = null;
      this.context = null;
    }

    this.vadDestroy = null;
  }
}

export default AudioManipulator;
